"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewSF = void 0;
var csod = require("player-core");
var application_1 = require("../../models/application");
var ApplicationWorkflowTracker_1 = require("../../shared/code/ApplicationWorkflowTracker");
var page_1 = require("../../pages/application/page");
function viewSF() {
    var _this = this;
    var view = {
        constructor: function (props) {
            _this.returnResultsToPage = view.returnResultsToPage.bind(_this);
            _this.setStateOnmultiChoiceSingleAnswerChange = view.setStateOnmultiChoiceSingleAnswerChange.bind(_this);
            _this.mapQuestionAnswer = view.mapQuestionAnswer.bind(_this);
            _this.buildVisibilityMap = view.buildVisibilityMap.bind(_this);
            _this.state = {
                questions: _this.props.actionItem.section.questions,
                userInput: (_this.props.actionItem.section.questions) ? _this.props.actionItem.section.questions.map(function (q) {
                    return _this.mapQuestionAnswer(q);
                }) : [],
                visibilityMap: {},
                getQuestionVisibility: function (questionId) {
                    var isVisible = _this.state.visibilityMap[questionId];
                    if (!isVisible) {
                        _this.state.questions.find(function (i) { return i.questionId == questionId; }).options.forEach(function (o) {
                            o.isChecked = false;
                        });
                    }
                    return isVisible;
                }
            };
            _this.returnResultsToPage(_this.props);
            _this.state.visibilityMap = _this.buildVisibilityMap();
        },
        willReceiveProps: function (nextProps) {
            if (nextProps.actionItem.id != _this.props.actionItem.id) {
                if (nextProps.actionItem.section.questions) {
                    _this.state.questions = nextProps.actionItem.section.questions;
                    _this.state.userInput = nextProps.actionItem.section.questions.map(function (q) { return _this.mapQuestionAnswer(q); });
                    _this.state.visibilityMap = _this.buildVisibilityMap();
                }
                _this.returnResultsToPage(nextProps);
            }
        },
        mounted: function () {
        },
        events: {
            yesNoChanged: function (value, id, booleanValue) {
                _this.setStateOnmultiChoiceSingleAnswerChange(value, id, booleanValue);
                _this.returnResultsToPage(_this.props);
            },
            trueFalseChanged: function (value, id, booleanValue) {
                _this.setStateOnmultiChoiceSingleAnswerChange(value, id, booleanValue);
                _this.returnResultsToPage(_this.props);
            },
            multiChoiceSingleAnswerChanged: function (value, id, booleanValue) {
                _this.setStateOnmultiChoiceSingleAnswerChange(value, id, null);
                _this.returnResultsToPage(_this.props);
            },
            multiChoiceMultiAnswerChanged: function (values, id) {
                _this.state.userInput.find(function (i) { return i.questionId == id; }).responses =
                    values.filter(function (v) { return v.isChecked; }).map(function (v) {
                        var response = {
                            responseId: v.responseId,
                            textValue: null,
                            dateValue: null,
                            intValue: null,
                            numericValue: null,
                            booleanValue: null
                        };
                        return response;
                    });
                _this.returnResultsToPage(_this.props);
            },
            dateChanged: function (value, questionId, responseId) {
                var responses = [];
                if (value !== null) {
                    responses.push({
                        responseId: responseId,
                        textValue: null,
                        dateValue: value,
                        intValue: null,
                        numericValue: null,
                        booleanValue: null
                    });
                }
                _this.state.userInput.find(function (i) { return i.questionId == questionId; }).responses = responses;
                _this.returnResultsToPage(_this.props);
            },
            freeFormEssayChanged: function (value, questionId, responseId) {
                var response = {
                    responseId: responseId,
                    textValue: value,
                    dateValue: null,
                    intValue: null,
                    numericValue: null,
                    booleanValue: null
                };
                _this.state.userInput.find(function (i) { return i.questionId == questionId; }).responses = [response];
                _this.returnResultsToPage(_this.props);
            },
            shortTextChanged: function (value, questionId, responseId) {
                var response = {
                    responseId: responseId,
                    textValue: value,
                    dateValue: null,
                    intValue: null,
                    numericValue: null,
                    booleanValue: null
                };
                _this.state.userInput.find(function (i) { return i.questionId == questionId; }).responses = [response];
                _this.returnResultsToPage(_this.props);
            },
            numericChanged: function (value, questionId, responseId) {
                var responses = [];
                if (value) {
                    responses.push({
                        responseId: responseId,
                        textValue: null,
                        dateValue: null,
                        intValue: null,
                        numericValue: value,
                        booleanValue: null
                    });
                }
                _this.state.userInput.find(function (i) { return i.questionId == questionId; }).responses = responses;
                _this.returnResultsToPage(_this.props);
            }
        },
        returnResultsToPage: function (properties) {
            var resultData = new application_1.PrescreeningResultData();
            resultData.actionId = properties.actionItem.id;
            resultData.type = application_1.ActionType.prescreeningQuestions;
            resultData.section = {
                answers: _this.state.userInput,
                workflowSectionId: properties.actionItem.section.workflowSectionId
            };
            properties.onDataChanged(resultData);
        },
        setStateOnmultiChoiceSingleAnswerChange: function (value, id, booleanValue) {
            var response = {
                responseId: value,
                textValue: null,
                dateValue: null,
                intValue: null,
                numericValue: null,
                booleanValue: booleanValue
            };
            _this.state.userInput.find(function (i) { return i.questionId == id; }).responses = [response];
            _this.state.visibilityMap = _this.buildVisibilityMap();
            _this.state.userInput.forEach(function (response) {
                var isQuestionVisible = _this.state.getQuestionVisibility(response.questionId);
                if (!isQuestionVisible) {
                    response.responses = [];
                }
            });
            _this.state.questions.find(function (i) { return i.questionId == id; }).errorMessage = '';
            csod.engine.commit();
        },
        buildVisibilityMap: function () {
            var triggers = this.state.userInput.filter(function (answer) { return (answer.type === 'YesNo'
                || answer.type === 'TrueFalse'
                || answer.type === 'MultipleChoiceSingleAnswer')
                && answer.responses
                && answer.responses.length > 0; })
                .reduce(function (triggerMap, responseData) {
                triggerMap[responseData.responses[0].responseId] = true;
                return triggerMap;
            }, {});
            var visibilityMap = {};
            this.state.questions.forEach(function (question) {
                if (!question.triggerIds || question.triggerIds.length < 1) {
                    visibilityMap[question.questionId] = true;
                }
                else {
                    var visible_1 = false;
                    question.triggerIds.forEach(function (triggerId) {
                        if (triggers[triggerId]) {
                            if (window.localStorage.getItem(ApplicationWorkflowTracker_1.ApplicationWorkflowEventTypes.doNotTrackSeenBPSQ) == null) {
                                window.localStorage.setItem(ApplicationWorkflowTracker_1.ApplicationWorkflowEventTypes.doNotTrackSeenBPSQ, 'true');
                                page_1.trackWorkflow(ApplicationWorkflowTracker_1.ApplicationWorkflowEventTypes.sawBranchedPSQ);
                            }
                            visible_1 = true;
                        }
                    });
                    visibilityMap[question.questionId] = visible_1;
                }
            });
            return visibilityMap;
        },
        mapQuestionAnswer: function (question) {
            var entry = {
                questionId: question.questionId,
                type: question.type,
                responses: question.options.filter(function (o) { return o.isChecked || (o.value && o.value != ''); }).map(function (o) {
                    var response = new application_1.PrescreeningResultDataResponse();
                    switch (question.type) {
                        case "FreeFormEssay":
                        case "ShortText":
                            response.responseId = o.responseId;
                            response.textValue = o.value;
                            response.dateValue = null;
                            response.intValue = null;
                            response.numericValue = null;
                            response.booleanValue = null;
                            break;
                        case "NumericValue":
                            response.responseId = o.responseId;
                            response.textValue = null;
                            response.dateValue = null;
                            response.intValue = null;
                            response.numericValue = o.value;
                            response.booleanValue = null;
                            break;
                        case "Date":
                            response.responseId = o.responseId;
                            response.textValue = null;
                            response.dateValue = o.value;
                            response.intValue = null;
                            response.numericValue = null;
                            response.booleanValue = null;
                            break;
                        case "MultipleChoiceMultipleAnswer":
                        case "MultipleChoiceSingleAnswer":
                            response.responseId = o.responseId;
                            response.textValue = null;
                            response.dateValue = null;
                            response.intValue = null;
                            response.numericValue = null;
                            response.booleanValue = null;
                            break;
                        case "YesNo":
                        case "TrueFalse":
                            response.responseId = o.responseId;
                            response.textValue = null;
                            response.dateValue = null;
                            response.intValue = null;
                            response.numericValue = null;
                            response.booleanValue = o.booleanValue;
                            break;
                    }
                    ;
                    return response;
                })
            };
            return entry;
        }
    };
    return view;
}
exports.viewSF = viewSF;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowPSQAction/ViewSF.js
// module id = 627
// module chunks = 0